<template>
  <form class="columns is-multiline" @submit.prevent="submit">
    <template v-if="isEditing">
      <b-field class="column is-6" label="Nombre" label-position="horizontal">
        <b-input v-model="form.nombre" disabled></b-input>
      </b-field>

      <b-field class="column is-6" label="Correo" label-position="horizontal">
        <b-input v-model="form.correo" type="email" disabled></b-input>
      </b-field>

      <b-field class="column is-6" label="Tipo" label-position="horizontal">
        <b-input :value="tipoLabel" disabled></b-input>
      </b-field>

      <b-field class="column is-6" label="Representante" label-position="horizontal">
        <b-input v-model="form.representante"></b-input>
      </b-field>

      <b-field class="column is-6" label="Correo representante" label-position="horizontal">
        <b-input v-model="form.correoRepresentante" type="email"></b-input>
      </b-field>
    </template>

    <template v-else>
      <!-- Selección múltiple para socio/invitado -->
      <template v-if="form.tipo === 'socio'">
        <b-field class="column is-12" label="Selecciona socios" label-position="horizontal">
          <multiselect
            v-model="selectedSocios"
            :options="sociosOptions"
            :multiple="true"
            track-by="id"
            label="label"
            placeholder="Buscar socios..."
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
          />
        </b-field>
      </template>

      <template v-else-if="form.tipo === 'invitado'">
        <b-field class="column is-12" label="Selecciona invitados" label-position="horizontal">
          <multiselect
            v-model="selectedInvitados"
            :options="invitadosOptions"
            :multiple="true"
            track-by="id"
            label="label"
            placeholder="Buscar invitados..."
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
          />
        </b-field>
      </template>

      <!-- Captura manual -->
      <template v-else>
        <b-field class="column is-6" label="Nombre *" label-position="horizontal">
          <b-input v-model="form.nombre" required></b-input>
        </b-field>

        <b-field class="column is-6" label="Correo *" label-position="horizontal">
          <b-input v-model="form.correo" type="email" required></b-input>
        </b-field>

        <b-field class="column is-6" label="Número socio" label-position="horizontal">
          <b-input v-model="form.numeroSocio"></b-input>
        </b-field>

        <b-field class="column is-6" label="Nombre socio" label-position="horizontal">
          <b-input v-model="form.nombreSocio"></b-input>
        </b-field>

        <b-field class="column is-6" label="Vigencia" label-position="horizontal">
          <b-input v-model="form.vigencia" type="date"></b-input>
        </b-field>

        <b-field class="column is-6" label="Representante" label-position="horizontal">
          <b-input v-model="form.representante"></b-input>
        </b-field>

        <b-field class="column is-6" label="Correo representante" label-position="horizontal">
          <b-input v-model="form.correoRepresentante" type="email"></b-input>
        </b-field>

<!--         <b-field class="column is-6" label="Código" label-position="horizontal" message="Se genera uno si se deja vacío.">
          <b-input v-model="form.codigo"></b-input>
        </b-field> -->
      </template>
    </template>

    <!-- Estatus comunes -->
    <b-field class="column is-6" label="Estatus de correo" label-position="horizontal">
      <b-select v-model="form.estatusCorreo" expanded>
        <option value="Enviado">Enviado</option>
        <option value="Pendiente">Pendiente</option>
      </b-select>
    </b-field>

    <b-field class="column is-6" label="Asistencia" label-position="horizontal">
      <b-select v-model="form.estatusAsistencia" expanded>
        <option value="Pendiente">Pendiente</option>
        <option value="Asistió">Asistió</option>
        <option value="Faltó">Faltó</option>
      </b-select>
    </b-field>

    <b-field v-if="form.estatusAsistencia === 'Faltó'" class="column is-6" label="Falta justificada" label-position="horizontal">
      <b-checkbox v-model="form.faltaJustificada">Sí, justificada</b-checkbox>
    </b-field>

    <div class="column is-12">
      <div class="buttons is-right">
        <b-button type="is-text" @click="$emit('cancel')">Cancelar</b-button>
        <b-button native-type="submit" type="is-primary" icon-left="content-save">Guardar</b-button>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components: {
    Multiselect,
  },
  props: {
    guest: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    presetType: {
      type: String,
      required: false,
    },
    sociosOptions: {
      type: Array,
      default: () => [],
    },
    invitadosOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {},
      defaults: {
        id: null,
        tipo: 'invitado',
        nombre: '',
        correo: '',
        numeroSocio: '',
        nombreSocio: '',
        vigencia: '',
        representante: '',
        correoRepresentante: '',
        estatusCorreo: 'Pendiente',
        estatusAsistencia: 'Pendiente',
        faltaJustificada: false,
        codigo: '',
      },
      selectedSocios: [],
      selectedInvitados: [],
    };
  },
  computed: {
    isEditing() {
      return Boolean(this.form && this.form.id);
    },
    tipoLabel() {
      const tipo = (this.form && this.form.tipo) || '';
      if (tipo === 'socio') return 'Socio';
      if (tipo === 'invitado') return 'Invitado';
      if (tipo === 'extra') return 'Manual';
      return 'Manual';
    },
  },
  watch: {
    guest: {
      immediate: true,
      handler(newGuest) {
        this.form = { ...this.defaults, ...(newGuest || {}) };
        if (this.presetType) {
          this.form.tipo = this.presetType;
        }
      },
    },
    presetType(newType) {
      if (newType) {
        this.form.tipo = newType;
      }
    },
  },
  methods: {
    submit() {
      if (this.isEditing) {
        this.$emit('save', { ...this.form });
        return;
      }
      // Si es socio/invitado y hay selección múltiple, emitimos un arreglo
      if (this.form.tipo === 'socio' && this.selectedSocios.length) {
        const payloads = this.selectedSocios.map((s) => ({
          tipo: 'socio',
          nombre: s.nombre,
          correo: s.email,
          numeroSocio: s.numeroSocio,
          nombreSocio: s.empresa,
          representante: '',
          correoRepresentante: '',
          estatusCorreo: this.form.estatusCorreo,
          estatusAsistencia: this.form.estatusAsistencia,
          codigo: '',
          socio_id: s.id,
        }));
        this.$emit('save', payloads);
        return;
      }

      if (this.form.tipo === 'invitado' && this.selectedInvitados.length) {
        const payloads = this.selectedInvitados.map((g) => ({
          tipo: 'invitado',
          nombre: g.nombre,
          correo: g.email,
          numeroSocio: '',
          nombreSocio: '',
          representante: '',
          correoRepresentante: '',
          estatusCorreo: this.form.estatusCorreo,
          estatusAsistencia: this.form.estatusAsistencia,
          codigo: '',
          invitado_id: g.id,
        }));
        this.$emit('save', payloads);
        return;
      }

      // Manual o sin selección múltiple
      this.$emit('save', { ...this.form });
    },
  },
};
</script>

<style scoped>
.buttons {
  margin-top: 10px;
}
</style>
